<script setup>
import { HubSpotFooterButton } from '@dashhudson/dashing-ui/button';
import { useSidePanel } from '@dashhudson/dashing-ui/side-panel';
import { Skeleton } from '@dashhudson/dashing-ui/skeleton';
import { computed, onMounted, onUnmounted } from 'vue';

import { VISION_AI_PANEL_TYPE } from '@/components/VisionAi/constants';
import { useHubspotFloatingStackLayout } from '@/composables/layout/useFloatingWidgetLayout';
import { useHubspotStore } from '@/stores/hubspot';

const hubspotStore = useHubspotStore();

const { visible: sidePanelVisible, type: sidePanelType } = useSidePanel();

const visionAiPanelOpen = computed(
  () => sidePanelVisible.value && sidePanelType.value === VISION_AI_PANEL_TYPE,
);

const { chatPanelTransformStyle, stackPositionClasses } = useHubspotFloatingStackLayout(
  () => visionAiPanelOpen.value,
);

function onToggleChat() {
  hubspotStore.toggle();
}

onMounted(() => {
  hubspotStore.chatMounted();
});

onUnmounted(() => {
  hubspotStore.chatUnmounted();
});
</script>

<template>
  <div :class="stackPositionClasses" :style="[{ zIndex: '9999' }, chatPanelTransformStyle]">
    <Transition name="expand">
      <div
        v-show="hubspotStore.showConversation"
        class="relative !origin-bottom-right !overflow-hidden rounded-lg bg-background-base elevation-5xl"
        :style="{ width: '376px', height: '530px' }"
      >
        <div id="dh-hubspot-chat" class="absolute h-full w-full" />
        <Skeleton v-if="hubspotStore.loadingWidget" height="100%" width="100%" />
      </div>
    </Transition>
    <div class="!flex !justify-end">
      <HubSpotFooterButton
        v-if="hubspotStore.ready"
        :open="hubspotStore.showConversation"
        @click="onToggleChat"
      />
    </div>
  </div>
</template>
